import { makeStyles } from '@mui/styles';
import { Colors } from '../../utils/color';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  check_container: {
    width: 14,
    height: 14,
    border: `1px solid ${Colors.LIGHT_GRAY}`,
    borderRadius: 4,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkedContainer: {
    backgroundColor: Colors.NEVY_BLUE,
  },
  checked_icon: {
    width: '60%',
    height: '88%',
    userDrag: 'none',
    userSelect: 'none',
    mozUserSelect: 'none',
    webkitUserDrag: 'none',
    webkitUserSelect: 'none',
    msUserSelect: 'none',
  },
  check_label: {
    marginLeft: 8,
    color: Colors.DARK_GRAY,
    fontSize: 12,
    fontWeight: 400,
  },
}));
